import React, {
  TextareaHTMLAttributes,
  useEffect,
  useRef,
  useState,
} from 'react';
import {
  ErrorMessage,
  InputWrapper,
  LabelContent,
  TextArea,
} from './CommentForm.style';

interface CommentFormTextAreaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: React.ReactNode;
  value: string;
  alwaysShowError?: boolean;
  focusOnMount?: boolean;
  errorMessage?: string;
}

export const CommentFormTextArea: React.FC<CommentFormTextAreaProps> = ({
  errorMessage,
  label,
  value,
  alwaysShowError,
  focusOnMount,
  ...otherProps
}) => {
  const [isTouched, setTouched] = useState(false);
  const [isChanged, setChanged] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [isFocusOnMount] = useState(focusOnMount);
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const showError = (alwaysShowError || (isTouched && isChanged)) && !isValid;

  useEffect(() => {
    if (isFocusOnMount) {
      inputRef.current.focus();
    }
  }, [isFocusOnMount]);

  useEffect(() => {
    const isValid = inputRef.current.checkValidity();
    setIsValid(isValid);
  }, [value]);

  return (
    <InputWrapper>
      <label>
        <LabelContent withAsterisk={label && otherProps.required}>
          {label}
        </LabelContent>
        <TextArea
          {...otherProps}
          ref={inputRef}
          onBlur={(e) => {
            setTouched(true);
            if (otherProps.onBlur) {
              otherProps.onBlur(e);
            }
          }}
          onChange={(e) => {
            setChanged(true);
            if (otherProps.onChange) {
              otherProps.onChange(e);
            }
          }}
          value={value}
          error={showError}
        />
      </label>
      {showError && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </InputWrapper>
  );
};
